import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import BranchServiceTimePerService from "../../../components/branches/reports/daily/BranchServiceTimePerService";
import {
  SERVICE_TIME_PER_SERVICE_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const asArray = (data) => (Array.isArray(data) ? data : [data]);

const DailyBranchServiceTimePerService = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={SERVICE_TIME_PER_SERVICE_COLUMN_DEFINITIONS}
    descriptionKey="ServiceTimePerServiceBranches"
    normalizeData={asArray}
    title={`${reportIndex}. Service Time Per Service`}
  >
    {({ data, renderConfig }) => (
      data.map((branch, index) => (
          <BranchServiceTimePerService
            key={index}
            branchId={branch.branchId}
            reportIndex={reportIndex}
            branchIndex={index + 1}
            data={branch.servicesData}
            branchName={branch.branchName}
            numServices={branch.numServices}
            renderConfig={renderConfig}
          />
        ))
    )}
  </DailyGeneratedReportPage>
);

export default DailyBranchServiceTimePerService;
